export const getTime = () => {

  const getSt = (val) => {
    const v = val.toString();
    return `${v.length === 1 ? '0': ''}${v}`
  };

  const date = new Date();
  const h = date.getHours();
  const m = date.getMinutes();
  return `${getSt(h)}:${getSt(m)}`
};
